import { Injectable } from '@angular/core';
import { NgbDateStruct, NgbDateParserFormatter, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '/';

  fromModel(value: string): NgbDateStruct {
    let result: any = null;
    if (value) {
      let date = value.toString().split(this.DELIMITER);
      result = {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10)
      };
    }
    return result;
  }

  toModel(date: NgbDateStruct): string {
    let result: any = null;
    if (date) {
      result = ((date.day < 10) ? "0" : "") + date.day
        + this.DELIMITER
        + ((date.month < 10) ? "0" : "") + date.month
        + this.DELIMITER
        + ((date.year < 10) ? "0" : "") + date.year;
    }
    return result;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDatepickerFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct {
    let result: any = null;
    if (value) {
      let date = value.split(this.DELIMITER);
      result = {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10)
      };
    }
    return result;
  }

  // final output is dd/mm/yyyy (ex. 01/01/2020)
  format(date: NgbDateStruct): string {
    let result: any = null;
    if (date) {
      result = ((date.day < 10) ? "0" : "") + date.day
        + this.DELIMITER
        + ((date.month < 10) ? "0" : "") + date.month
        + this.DELIMITER
        + ((date.year < 10) ? "0" : "") + date.year;
    }
    return result;
  }
}
